import React, { useState } from "react";
import { Card, Table, Form, Row, Col, Dropdown } from "react-bootstrap";
import { FiEye, FiDownload } from "react-icons/fi";
import ViewCertificateModal from "../../../components/modals/hrm/training/certificationtracking/ViewCertificateModal";
import CertificationTrackingHeader from "../../../components/hrm/training/CertificationTrackingHeader";
// import ViewCertificateModal from "./ViewCertificateModal";
const initialData = [
  {
    id: 1,
    name: "Anthony Lewis",
    img: "/assets/img/users/user-32-1.jpg",
    training: "Git Training",
    trainer: "Harold Gaynor",
    trainerImg: "/assets/img/users/user-01.jpg",
    date: "14 Jun 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 2,
    name: "Brian Villalobos",
    img: "/assets/img/users/user-09.jpg",
    training: "HTML Training",
    trainer: "Sandra Ornellas",
    trainerImg: "/assets/img/users/user-02.jpg",
    date: "25 May 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 3,
    name: "Harvey Smith",
    img: "/assets/img/users/user-01-1.jpg",
    training: "React Training",
    trainer: "John Harris",
    trainerImg: "/assets/img/users/user-03.jpg",
    date: "10 May 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 4,
    name: "Stephan Peralt",
    img: "/assets/img/users/user-33-1.jpg",
    training: "Nodejs Training",
    trainer: "Whitney Barnette",
    trainerImg: "/assets/img/users/user-04.jpg",
    date: "28 Apr 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 5,
    name: "Doglas Martini",
    img: "/assets/img/users/user-34.jpg",
    training: "Django Training",
    trainer: "Richard Thompson",
    trainerImg: "/assets/img/users/user-05.jpg",
    date: "15 Apr 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 6,
    name: "Linda Ray",
    img: "/assets/img/users/user-06.jpg",
    training: "Java Training",
    trainer: "Kerry Drake",
    trainerImg: "/assets/img/users/user-07.jpg",
    date: "20 Mar 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 7,
    name: "Elliot Murray",
    img: "/assets/img/users/user-08.jpg",
    training: "MySQL Training",
    trainer: "David Carmona",
    trainerImg: "/assets/img/users/user-09.jpg",
    date: "10 Mar 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 8,
    name: "Rebecca Smith",
    img: "/assets/img/users/user-10.jpg",
    training: "DevOps Training",
    trainer: "Margaret Soto",
    trainerImg: "/assets/img/users/user-11.jpg",
    date: "17 Feb 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 9,
    name: "Daniel Carter",
    img: "/assets/img/users/user-12.jpg",
    training: "Python Training",
    trainer: "Sophia Lee",
    trainerImg: "/assets/img/users/user-13.jpg",
    date: "05 Feb 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 10,
    name: "Olivia Brown",
    img: "/assets/img/users/user-14.jpg",
    training: "UI/UX Training",
    trainer: "Emma Watson",
    trainerImg: "/assets/img/users/user-15.jpg",
    date: "25 Jan 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 11,
    name: "James Anderson",
    img: "/assets/img/users/user-16.jpg",
    training: "Angular Training",
    trainer: "Chris Evans",
    trainerImg: "/assets/img/users/user-17.jpg",
    date: "12 Jan 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
  {
    id: 12,
    name: "Isabella Martinez",
    img: "/assets/img/users/user-18.jpg",
    training: "AWS Training",
    trainer: "Robert Downey",
    trainerImg: "/assets/img/users/user-19.jpg",
    date: "02 Jan 2025",
    status: "Issued",
    certificate: "/assets/img/certificate.jpg",
  },
];

export default function CertificationTrackingPage() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const filtered = data.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "certificate.jpg";
    link.click();
  };

  return (

    <div  style={{ padding: "15px", background: "#f8f9fa",  }} >
      <CertificationTrackingHeader/>

         <Card style={{ borderRadius: 10 }}>
      {/* HEADER */}
      <Card.Header
        style={{
          background: "#fff",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <h5 style={{ fontWeight: 600 }}>Certification List</h5>

         <Dropdown>
               <Dropdown.Toggle variant="light" className="text-dark bg-white border border-1">
                 Sort By : Last 7 Days
               </Dropdown.Toggle>
   
               <Dropdown.Menu align="end">
                 <Dropdown.Item>Recently Added</Dropdown.Item>
                 <Dropdown.Item>Ascending</Dropdown.Item>
                 <Dropdown.Item>Descending</Dropdown.Item>
               </Dropdown.Menu>
             </Dropdown>
          
      </Card.Header>

      <Card.Body>
        {/* FILTER */}
        <Row className="mb-3">
          <Col md={6}>
            Row Per Page{" "}
            <Form.Select style={{ width: 80, display: "inline-block" }}>
              <option>10</option>
            </Form.Select>{" "}
            Entries
          </Col>

          <Col md={6} className="text-md-end mt-2 mt-md-0">
            <Form.Control
              placeholder="Search"
              style={{ maxWidth: 250, display: "inline-block" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive">
          <Table hover>
            <thead style={{ background: "#f8fafc" }}>
              <tr>
                <th><Form.Check /></th>
                <th>Employee Name</th>
                <th>Training Type</th>
                <th>Trainer Name</th>
                <th>Date</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item) => (
                <tr key={item.id}>
                  <td><Form.Check /></td>

                  {/* EMPLOYEE */}
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <img
                        src={item.img}
                        alt=""
                        style={{
                          width: 35,
                          height: 35,
                          borderRadius: "50%",
                        }}
                      />
                      {item.name}
                    </div>
                  </td>

                  <td>{item.training}</td>

                  {/* TRAINER */}
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <img
                        src={item.trainerImg}
                        alt=""
                        style={{
                          width: 35,
                          height: 35,
                          borderRadius: "50%",
                        }}
                      />
                      {item.trainer}
                    </div>
                  </td>

                  <td style={{ color: "#6b7280" }}>{item.date}</td>

                  {/* STATUS */}
                  <td>
                    <span
                      style={{
                        background: "#22c55e",
                        color: "#fff",
                        padding: "4px 10px",
                        borderRadius: 6,
                        fontSize: 12,
                      }}
                    >
                      ● Issued
                    </span>
                  </td>

                  {/* ACTIONS */}
                  <td>
                    <div style={{ display: "flex", gap: 12 }}>
                      <FiEye
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelected(item);
                          setShowModal(true);
                        }}
                      />

                      <FiDownload
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDownload(item.certificate)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>

      {/* MODAL */}
      <ViewCertificateModal
        show={showModal}
        onHide={() => setShowModal(false)}
        data={selected}
      />
    </Card>
    </div>
 
  );
}